import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Heading, Paragraph } from '@digdir/designsystemet-react';
import type { WorkEnvironmentEvaluation } from '../../../api/workEnvironmentTypes';
import { changeCounts } from '../evaluationView';
import process from '../WorkEnvironmentSurveyProcess.module.css';
import classes from './Evaluation.module.css';

type Props = {
  areas: NonNullable<WorkEnvironmentEvaluation['result']>['areas'];
};

const CHANGES = ['better', 'same', 'worse'] as const;

export const SummaryCard = ({ areas }: Props): ReactElement => {
  const { t } = useTranslation();
  const counts = changeCounts(areas);
  return (
    <section
      aria-labelledby="evaluation-summary-heading"
      className={`${process.card} ${process.sideCard}`}
    >
      <Heading level={2} data-size="xs" id="evaluation-summary-heading">
        {t('workEnvironmentEvaluation.result.summary.title')}
      </Heading>
      <dl className={classes.counts}>
        {CHANGES.map((change) => (
          <div key={change} className={classes.countBox} data-change={change}>
            <dt className="ds-paragraph" data-size="xs">
              {t(`workEnvironmentEvaluation.result.summary.${change}`)}
            </dt>
            <dd className="ds-heading" data-size="md">
              {counts[change]}
            </dd>
          </div>
        ))}
      </dl>
      <Paragraph data-size="sm">
        {[
          t('workEnvironmentEvaluation.result.summary.count', {
            count: areas.length,
          }),
          counts.stillHigh > 0
            ? t('workEnvironmentEvaluation.result.summary.stillHigh', {
                count: counts.stillHigh,
              })
            : t('workEnvironmentEvaluation.result.summary.noneHigh'),
        ].join(' ')}
      </Paragraph>
    </section>
  );
};
